import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Palatal Injection Treatment Cost for Snoring in Delhi, India</title>
            <meta name="description" content="Get advanced palatal injection treatment for snoring in Delhi. A quick, safe, minimally invasive procedure to reduce snoring and improve sleep quality. Book consultation today." />
            <meta name="keywords" content="Sleep apnoea solutions in Delhi NCR" />
            <link rel="canonical" href="https://entdelhi.com/palatal-injection-for-snoring/" />
            <meta property="og:title" content="Palatal Injection Treatment Cost for Snoring in Delhi, India" />
            <meta property="og:description" content="Get advanced palatal injection treatment for snoring in Delhi. A quick, safe, minimally invasive procedure to reduce snoring and improve sleep quality. Book consultation today." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
